import React from 'react';

import Layout from 'ui/Layout';
import RoutesView from 'ui/RoutesView';

const App = () => {
  return (
    <Layout>
      <RoutesView />
    </Layout>
  );
};

export default App;
